<template>
  <span class="nt2" v-if="message_bar.message_bar_content.is_link_out === true">
    <a
      v-if="isTicketsPage"
      class="f6 f5-ns tc pb0 mb1 lh-solid is-tablet-bold is-beige right-arrow-hover"
      :href="message_bar.tickets_message_bar_content.link"
      target="_blank"
    >
      {{ message_bar.tickets_message_bar_content.text }}&nbsp;&nbsp;<span
        style="font-weight: 800"
        >{{ message_bar.tickets_message_bar_content.link_copy }}</span
      >&nbsp;<span class="dib w2"
        ><simple-svg
          class="right-arrow is-cream pt2"
          :filepath="'/uploads/checkout-arrow.svg'"
        ></simple-svg
      ></span>
    </a>
    <a
      v-else
      class="f6 f5-ns tc pb0 mb1 lh-solid is-tablet-bold is-beige right-arrow-hover"
      :href="message_bar.message_bar_content.link"
      target="_blank"
    >
      {{ message_bar.message_bar_content.text }}&nbsp;&nbsp;<span
        style="font-weight: 800"
        >{{ message_bar.message_bar_content.link_copy }}</span
      >&nbsp;<span class="dib w2"
        ><simple-svg
          class="right-arrow is-cream pt2"
          :filepath="'/uploads/checkout-arrow.svg'"
        ></simple-svg
      ></span>
    </a>
  </span>
  <span
    class="nt2"
    v-else-if="
      message_bar.tickets_message_bar_content.is_link_out === true && isTicketsPage
    "
  >
    <a
      class="f6 f5-ns tc pb0 mb1 lh-solid is-tablet-bold is-beige right-arrow-hover"
      :href="message_bar.tickets_message_bar_content.link"
      target="_blank"
    >
      {{ message_bar.tickets_message_bar_content.text }}&nbsp;&nbsp;<span
        style="font-weight: 800"
        >{{ message_bar.tickets_message_bar_content.link_copy }}</span
      >&nbsp;<span class="dib w2"
        ><simple-svg
          class="right-arrow is-cream pt2"
          :filepath="'/uploads/checkout-arrow.svg'"
        ></simple-svg
      ></span>
    </a>
  </span>
  <span class="nt2" v-else>
    <router-link
      v-if="isTicketsPage"
      class="f6 f5-ns tc pb0 mb1 lh-solid is-tablet-bold is-beige right-arrow-hover"
      :to="message_bar.tickets_message_bar_content.link"
    >
      {{ message_bar.tickets_message_bar_content.text }}&nbsp;&nbsp;<span
        style="font-weight: 800"
        >{{ message_bar.tickets_message_bar_content.link_copy }}</span
      >&nbsp;<span class="dib w2"
        ><simple-svg
          class="right-arrow is-cream pt2"
          :filepath="'/uploads/checkout-arrow.svg'"
        ></simple-svg
      ></span>
    </router-link>
    <router-link
      v-else
      class="f6 f5-ns tc pb0 mb1 lh-solid is-tablet-bold is-beige right-arrow-hover"
      :to="message_bar.message_bar_content.link"
    >
      {{ message_bar.message_bar_content.text }}&nbsp;&nbsp;<span
        style="font-weight: 800"
        >{{ message_bar.message_bar_content.link_copy }}</span
      >&nbsp;<span class="dib w2"
        ><simple-svg
          class="right-arrow is-cream pt2"
          :filepath="'/uploads/checkout-arrow.svg'"
        ></simple-svg
      ></span>
    </router-link>
  </span>
</template>
<script>
export default {
  data() {
    return {
      isTicketsPage: false,
    };
  },
  created() {
    this.$route.path === "/tickets/"
      ? (this.isTicketsPage = true)
      : (this.isTicketsPage = false);
    this.$route.path === "/night-shows/"
      ? (this.isTicketsPage = true)
      : (this.isTicketsPage = false);  
  },
  watch: {
    $route(to, from) {
      this.$route.path === "/tickets/"
        ? (this.isTicketsPage = true)
        : (this.isTicketsPage = false);
    },
  },
  computed: {
    message_bar: function () {
      var contentData = this.$store.getters.filterPagesByName("message-bar.markdown");
      return contentData[0];
    },
  },
};
</script>
